module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "title1"
  }, [_vm._v("TAKE "), _c('span', {
    staticClass: "tit"
  }, [_vm._v("THE")])]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_vm._v("FIRST")]), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("SHOT")]), _vm._v(" "), _c('p', {
    staticClass: "title-para"
  }, [_vm._v("Strategies to Fire You Up"), _c('br'), _vm._v("and Change Your Life")]), _vm._v(" "), _c('p', {
    staticClass: "title-paras"
  }, [_vm._v("— PART OF THE "), _c('span', {
    staticClass: "big"
  }, [_vm._v("REVOLUTIONIZE")]), _c('sup', [_vm._v("®")]), _vm._v(" SERIES —")]), _vm._v(" "), _c('p', {
    staticClass: "title-author"
  }, [_vm._v("PEGGY CARUSO")]), _vm._v(" "), _c('p', {
    staticClass: "publisheri"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pub.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "publisher"
  }, [_vm._v("NEW YORK")]), _vm._v(" "), _c('p', {
    staticClass: "publishers"
  }, [_vm._v("LONDON • NASHVILLE • MELBOURNE • VANCOUVER")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c5c1d2c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/title.vue
// module id = 66
// module chunks = 0